<template>
	<section class="relativeclass">
		<label>{{ title }}<span class="asterik">*</span></label>
		<b-form-input
			:class="{ error: validation }"
			v-model.trim="projectTitle"
			:type="valType"
			:placeholder="placeholder"
			class="common-InputField"
			@keypress="handleKeyPress"
			@paste="handlePaste"
			:disabled="disabled"
		/>

		<div
			style="position: absolute; top: 35px; right: 12px"
			v-if="validation"
			v-b-popover.hover.top.v-danger="{
				content: validationMessage ? validationMessage : 'Required',
			}"
			variant="primary"
		>
			<img src="../../assets/deletepopupicon.svg" alt="" />
		</div>
	</section>
</template>

<script>
export default {
	name: "InputComponent",
	props: {
		validationMessage: {
			type: String,
		},
		validation: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: "input",
		},
		value: {
			type: [String, Number],
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		valType: {
			type: String,
			default: "text",
		},
		toFixed: {
			type: Boolean,
			default: false,
		},
		toFixedTotwo: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: "Enter",
		},
	},
	data() {
		return {
			projectTitle: this.value,
		};
	},
	watch: {
		projectTitle(newVal) {
			this.$emit("input", newVal);
		},
		value(newVal) {
			this.projectTitle = newVal;
		},
	},
	methods: {
		handleKeyPress(event) {
			if (this.title === "Marks") {
				const char = String.fromCharCode(event.keyCode || event.which);
				if (!/[0-9]/.test(char) || this.projectTitle.length >= 3) {
					event.preventDefault();
				}
			}
			if (this.toFixedTotwo) {
				const char = String.fromCharCode(event.keyCode || event.which);
				if (!/[0-9]/.test(char) || this.projectTitle.length >= 2) {
					event.preventDefault();
				}
			}
			if (this.toFixed) {
				const charCode = event.keyCode || event.which;
				const charTyped = String.fromCharCode(charCode);
				const regex = /^(?!0{2,})\d{1,4}(?:\.\d{0,2})?$/;
				if (!regex.test(event.target.value + charTyped)) {
					event.preventDefault();
				}
			}
		},
		handlePaste(event) {
			if (this.title === "Marks") {
				const paste = (event.clipboardData || window.clipboardData).getData(
					"text"
				);
				const digits = paste.replace(/\D/g, "").slice(0, 3);
				this.projectTitle = digits;
				this.$emit("input", digits);
				event.preventDefault();
			}
		},
	},
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
input[type="number"] {
	-moz-appearance: textfield;
	appearance: textfield;
}

.common-InputField {
	box-sizing: border-box;
	padding: 10px 27px 10px 14px;
	background: var(--color-white);
	/* border: 1px solid #d0d5dd !important; */
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: var(--subheading-color);
	height: 100%;
}

.common-InputField:disabled {
	box-sizing: border-box;
	padding: 10px 27px 10px 14px;
	background: #f7f7f7;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: var(--subheading-color);
	height: 100%;
	border: 1px solid #d0d5dd;
}
.common-InputField::placeholder {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
}
</style>
